import { render, staticRenderFns } from "./ownership.vue?vue&type=template&id=0083a956&scoped=true"
import script from "./ownership.vue?vue&type=script&lang=js"
export * from "./ownership.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0083a956",
  null
  
)

export default component.exports